import { Spinner } from "@components/ui/spinner";
import { zodResolver } from "@hookform/resolvers/zod";
import { endpoint } from "@services/api.services";
import { METHODS } from "@services/interface.service";
import { useQueryClient } from "@tanstack/react-query";
import { SkeletonTwo } from "@ui/external/components/skeleton";
import { getInputField } from "@utils/function/index.function";
import {
  removeHttpPrefix,
  showToast,
  throwErrorAlert,
} from "@utils/helper/index.helper";
import { useHandleAction, usePathname } from "@utils/hook/index.hook";
import { FormField } from "@utils/interface/form.interface";
import { PopupFormData, PopupSchema } from "@utils/interface/form.schema";
import { IndividualQuery } from "@utils/interface/index.interface";
import { PopupFetchData } from "@utils/interface/journey.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { usePending, useSelectionStore } from "@utils/states/index.state";
import { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useSearchParams } from "react-router";

const PopupForm: React.FC = () => {
  const { handleAction } = useHandleAction({
    endpoint: endpoint[""],
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const pathname = usePathname();
  const queryClient = useQueryClient();
  const modalItem = searchParams.get("modal-item");
  const modalMode = searchParams.get("modal");
  let {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm<PopupFormData>({
    mode: "onChange",
    resolver: zodResolver(PopupSchema),
    // defaultValues: {
    //   name: "",
    //   link: "",
    //   duration_in_seconds: "",
    //   is_skipable: false,
    //   is_show: false,
    //   image: "",
    // },
  });
  const { setIsFormPending, isFormPending } = useSelectionStore();

  const { data: fetchData, isPending: fetchPending } = useListData<
    IndividualQuery<PopupFetchData>
  >({
    endpoint: endpoint["popup"],
    key: `${pathname}-${modalItem}`,
    enabled: modalItem ? true : false,
    id: modalItem || "",
    window: false,
  });

  console.log(fetchData, "fetchData");
  /* set default value */
  const { setIsRetrive }: any = usePending();

  useEffect(() => {
    setIsRetrive(modalItem ? fetchPending : false);
    if (fetchData?.status === 200 && !fetchPending) {
      const firstResult = fetchData?.data;
      console.log(firstResult);
      if (firstResult) {
        if (modalMode == "add") {
          return reset({});
        } else {
          reset({
            ...firstResult,
            link: removeHttpPrefix(firstResult.link),
          });
        }
      }
    }
  }, [fetchData?.data, fetchPending]);

  const handleMutate = (data: any) => {
    setIsFormPending(true);

    if (modalItem) {
      data = {
        ...data,
        id: modalItem,
      };
    }

    data = {
      ...data,
    };
    if (data.link) {
      data.link = "https://" + removeHttpPrefix(data.link as string);
    }
    // if (!(data.image instanceof File || data.image instanceof Blob))
    //   delete data.image;
    return {
      data,
      endpoint: endpoint["popup"],
      method: modalItem ? METHODS.PUT : METHODS.POST,
    };
  };
  const handleSuccess = async ({
    status,
  }: {
    data: PopupFetchData;
    status: number;
  }) => {
    setIsFormPending(false);
    if ([200, 201].includes(status)) {
      setIsFormPending(false);
      queryClient.invalidateQueries({ queryKey: [`${pathname}-listing`] });
      showToast({
        description: `Popup Ads ${status === 200 ? "Updated" : "Created"}`,
        type: "success",
        title: "Success",
      });

      handleAction({
        type: "modal-close",
      });
    } else {
      return new Error("Unknown API Error");
    }
  };
  console.log("errors", errors);
  const handleError = async (error: any) => {
    console.log(error.data.data, "error00");
    setIsFormPending(false);
    if (error?.data?.status == 413) {
      showToast({
        description: "File Size Too Large",
        type: "error",
        title: "Error",
      });
    }

    throwErrorAlert(error.data.data);
  };

  const { mutate } = usePostData();

  /** =========================================== Invoice Course List api ==================================================== **/

  // const {} = useListData({
  //   endpoint: endpoi
  // })

  /** =============================================================================================== **/

  const onSubmit: SubmitHandler<PopupFormData> = (data) => {
    //Add Mutation Data
    console.log("this is the data submited", data);
    mutate(handleMutate(data), {
      onSuccess: ({ data, status }) => handleSuccess({ data, status }),
      onError: (data) => handleError({ data }),
    });
  };

  const formSchema: FormField[] = [
    {
      name: "name",
      label: "Popup Title",
      colSpan: 12,
      type: "text",
      placeholder: "Enter Popup Title",
      control: control,
      setValue: setValue,
      errors,
      className: `mb-[20px] min-w-full w-full`,
      visable: true,
    },
    {
      name: "link",
      label: "Link",
      colSpan: 12,
      type: "prefixinput",
      placeholder: "Enter Popup Link",
      control: control,
      setValue: setValue,
      errors,
      className: `mb-[20px] min-w-full w-full`,
      visable: true,
    },
    {
      name: "duration_in_seconds",
      label: "Durations in Second",
      colSpan: 12,
      type: "text",
      placeholder: "Enter Durations in Seconds",
      control: control,
      setValue: setValue,
      errors,
      className: `mb-[20px] min-w-full w-full`,
      visable: true,
    },
    {
      name: "expiration_date",
      label: "Expiration Date",
      colSpan: 12,
      type: "date",
      placeholder: "Enter Durations in Seconds",
      control: control,
      setValue: setValue,
      errors,
      className: `mb-[40px] min-w-full w-full`,
      visable: true,
    },
    {
      name: "is_skipable",
      label: "Is Skipable",
      colSpan: 6,
      type: "switch",
      placeholder: "Enter ",
      control: control,
      setValue: setValue,
      errors,
      className: `mb-[20px] min-w-full w-full`,
      visable: true,
    },
    {
      name: "is_show",
      label: "Is Show",
      colSpan: 6,
      type: "switch",
      placeholder: "Enter ",
      control: control,
      setValue: setValue,
      errors,
      className: `mb-[20px] min-w-full w-full`,
      visable: true,
    },
    {
      name: "image",
      label: "Image",
      colSpan: 12,
      type: "cropper",
      placeholder: "Enter ",
      control: control,
      setValue: setValue,
      errors,
      className: `mb-[20px] min-w-full w-full`,
      visable: true,
    },
    {
      type: "submit",
      value: "Submit",
      className: "w-full h-[47px] mt-[32px] capitalize",
      colSpan: 12,
      variant: "default",
      endIcon: isFormPending ? <Spinner /> : null,
      disabled: isFormPending ? true : false,
      visable: true,
    },
  ];

  if (fetchPending && modalItem)
    return (
      <>
        <SkeletonTwo />
      </>
    );

  return (
    <>
      <form
        id={pathname}
        onSubmit={handleSubmit(onSubmit)}
        className="row w-full"
      >
        <div className="col-lg-12">
          <div className="row">
            {formSchema.map(
              (field, index) =>
                (field.visable || field.visable == undefined) && (
                  <div
                    key={index}
                    className={`col-lg-${field.colSpan} col-12 lg:px-[12px] px-[8px]`}
                  >
                    {getInputField({ ...field })}
                  </div>
                )
            )}
          </div>
        </div>
      </form>
    </>
  );
};
export { PopupForm };
